import { PropsWithChildren } from 'react';

export function ActionSubMenu({ children }: PropsWithChildren<{}>) {
  return (
    <div className="flex flex-col rounded-200 bg-primary shadow-100 items-stretch justify-start w-fit">{children}</div>
  );
}
